<div class="main-content">
  <ng-template dynamic-content></ng-template>

  <div class="spinner-container" *ngIf="loading$ | async">
    <mat-spinner class="spinner-indicator"></mat-spinner>
  </div>
</div>
